import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

/**
 * Guard that redirects users to their default landing page based on access level
 */
export const defaultRedirectGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  
  if (!auth.isAuthenticated()) {
    router.navigate(['/login']);
    return false;
  }
  
  const accessLevel = auth.accessLevel();
  
  if (accessLevel === 'full') {
    router.navigate(['/details']);
  } else if (accessLevel === 'polterabend') {
    router.navigate(['/polter']);
  } else {
    router.navigate(['/login']);
  }
  
  return false; // Always redirect, never allow access to empty path
};